module.exports = __webpack_public_path__ + "media/images/emblems/Uebeschi-coat_of_arms-643069a670d68c8c717173be07d494ba.svg";